import _extends from "@babel/runtime-corejs2/helpers/esm/extends";
import React from "react";
import { rangeSpec } from "../../utils";
function UpDownWidget(props) {
  var BaseInput = props.registry.widgets.BaseInput;
  return React.createElement(BaseInput, _extends({
    type: "number"
  }, props, rangeSpec(props.schema)));
}
if (process.env.NODE_ENV !== "production") {}
export default UpDownWidget;